import { Component, ViewEncapsulation } from '@angular/core';
import { AlertsService, AlertilteredCategories } from './alerts.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Rx';
import 'rxjs/add/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
const INTERVAL = 50 * 1000;
import { ClrDatagridStringFilterInterface } from "@clr/angular";
import { ClrDatagridComparatorInterface, ClrDatagridSortOrder } from "@clr/angular"
import { DatePipe } from '@angular/common';
import { ClientUtilities } from './utils/client-utils';
import { GlobalVariables } from '../../../common/global-variables';
class EntityNameFilter implements ClrDatagridStringFilterInterface<any> {
    accepts(row: any, search: string): boolean {
        return row.entity.name.toLowerCase().indexOf(search.toLowerCase()) >= 0;
    }
}
class MessageFilter implements ClrDatagridStringFilterInterface<any> {
    accepts(row: any, search: string): boolean {
        return row.message.toLowerCase().indexOf(search.toLowerCase()) >= 0;
    }
}
class CreationDateFilter implements ClrDatagridStringFilterInterface<any> {
    constructor(private datePipe: DatePipe) { }
    accepts(row: any, search: string): boolean {
        let dateString = this.datePipe.transform(row.creation_date, 'MMM d, h:mm:ss a');
        return dateString.toString().toLowerCase().indexOf(search.toLowerCase()) >= 0;
    }
}
class SortByCreationDate implements ClrDatagridComparatorInterface<any> {
    compare(a: any, b: any) {
        return a.creation_date - b.creation_date;
    }
}
@Component({
    selector: 'app',
    encapsulation: ViewEncapsulation.None,
    styles: [require('./alerts.scss')],
    template: require('./alerts.component.html')
})

export class AlertApp {
    public alertsData: any = [];
    public alertsToDisplay: any = [];
    public isError: boolean = false;
    public message: string = '';
    public loading: boolean = true;
    public alertSubscribeHandler: Subscription;
    public allVCSubscribeHandler: Subscription;
    public allVCs: any = [];
    private isVsphereClient: boolean = false;
    public allVCsRequest: any = [];
    private entityNameFilter: EntityNameFilter = new EntityNameFilter();
    private creationDateFilter: EntityNameFilter = new CreationDateFilter(this.datePipe);
    private messageFilter: MessageFilter = new MessageFilter();
    private sortByCreationDate = new SortByCreationDate();
    private sortInReverseChronology = ClrDatagridSortOrder.DESC;
    private filteredCategories: string[] = [AlertilteredCategories.INFO, AlertilteredCategories.WARNING, AlertilteredCategories.CRITICAL];
    public widgetExpanded = false;
    private showInfoAlertFlag: boolean = true;
    private showMe: boolean = false;
    constructor(private alertsService: AlertsService, private translate: TranslateService, private datePipe: DatePipe) {
        const path = (window.location.pathname.match(/(.*)(\/alerts-ui)(\/.*|$)/) || [])[1];
        this.isVsphereClient = !!path && ClientUtilities.runningInPluginUI();
        this.initializeTranslations();


    }

    initializeTranslations() {
        let userLang = navigator.language.split('-')[0];
        userLang = GlobalVariables.SUPPORTED_LOCALES.indexOf(userLang) !== -1 ? userLang : 'en';
        GlobalVariables.LOCALE = userLang;
        this.translate.setDefaultLang('en');
        this.translate.use(userLang);
    }

    public ngOnInit() {
        this.allVCSubscribeHandler = this.alertsService.getAllVCs()
            .subscribe(
                (vcList) => {
                    if (vcList.length) {
                        vcList.forEach((vc) => {
                            this.allVCs.push(vc.serverGuid);
                            this.allVCsRequest.push(this.alertsService.getAlerts(vc.serverGuid));
                        });
                        this.getAlertsData(this.allVCsRequest);
                        setInterval(() => { this.getAlertsData(this.allVCsRequest); }, INTERVAL);
                    } else {
                        let errorMessage = this.translate.instant('alerts.alertCardVcErrorMessage');
                        this.errorHandler(errorMessage);
                    }
                }
            );
    }

    public getAlertsData(allVCsRequest: any) {
        this.alertSubscribeHandler = Observable.forkJoin(allVCsRequest).subscribe(
            (data) => {
                    this.alertsData = [];
                    for (let vcAlerts of data) {
                        this.alertsData = this.alertsData.concat(vcAlerts['items']);
                    }
                    this.prepareViewModel();
                    this.alertsToDisplay = this.alertsData.filter(alert => this.filteredCategories.indexOf(alert.severity) > -1);
                    this.loading = false;
            },
            (error) => { this.errorHandler(error); }
        );
    }

    public prepareViewModel() {
        if (this.alertsData && this.alertsData.length > 0) {
            this.alertsData.forEach((alert) => {
                if (!!alert && !!alert.creation_date) {
                    let date: Date = new Date(alert.creation_date);
                    let utcDate = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                    alert.creation_date = utcDate;
                }
            });
        }
    }

    public ngOnDestroy() {
        if (this.allVCSubscribeHandler) {
            this.allVCSubscribeHandler.unsubscribe();
        }
        if (this.alertSubscribeHandler) {
            this.alertSubscribeHandler.unsubscribe();
        }
    }

    public errorHandler(error: any) {
        this.isError = true;
        this.loading = false;
        this.message = this.translate.instant('alerts.errMsg');
    }

    private filterCategories(category: string, flag: boolean) {
        if (flag)
            this.filteredCategories.push(category);
        else
            this.filteredCategories.splice(this.filteredCategories.indexOf(category), 1);
        this.alertsToDisplay = this.alertsData.filter(alert => this.filteredCategories.indexOf(alert.severity) > -1);
    }

    public onCategorySelectionChange(category: string, event) {
        if (category === AlertilteredCategories.INFO) this.showInfoAlertFlag = event.target.checked;
        this.filterCategories(category, event.target.checked);
    }

    public acknowledgeAlert(alert: any) {
        this.alertsService.acknowledgeAlert(alert.alarm_id, alert.instanceId)
            .subscribe((response) => {
                this.loading = true;
                this.getAlertsData(this.allVCsRequest);
            }, (error) => {
                this.isError = true;
                this.message = error.errorMessage;
            });
    }

    public deleteAlert(alert: any) {
        this.alertsService.deleteAlert(alert.alarm_id, alert.instanceId)
            .subscribe((response) => {
                this.loading = true;
                this.getAlertsData(this.allVCsRequest);
            }, (error) => {
                this.isError = true;
                this.message = error.errorMessage;
            })
    }
    public toggleInfoAlerts(event) {
        this.showInfoAlertFlag = !this.showInfoAlertFlag;
        this.filterCategories(AlertilteredCategories.INFO, this.showInfoAlertFlag);

    }

    public expandMessage(index){
        let selectedRow = document.querySelectorAll('.datagrid-expandable-caret-button') ;
        let element = selectedRow[index] as HTMLElement;
        element.click();
    }
}





// WEBPACK FOOTER //
// ./src/alerts/src/alerts-ui/alerts.component.ts